import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Filter, Sliders } from "react-feather";
import Select from "react-select";
import { Globe, User } from "react-feather";
import ImageWithBasePath from "../../img/imagewithbasebath";
import Table from "../../pagination/datatable";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import AddWarehouse from "./addWarehouse";
import useWarehouse from "../../../controllers/useWarehouse";
import EditWarehouse from "./editWarehouse";
// import { OverlayTrigger } from "react-bootstrap";
// import {
//   ChevronUp,
//   PlusCircle,
//   RotateCcw,
// } from "feather-icons-react/build/IconComponents";
// import { Tooltip } from "antd";
// import { useSelector, useDispatch } from "react-redux";
// import { setToogleHeader } from "../../redux/action";
// import moment from "moment";
import Breadcrumbs from "../../breadcrumbs";
import usePermissions from "../../hooks/usePermissions";
const WareHouses = () => {
  // const dispatch = useDispatch();
  // const data = useSelector((state) => state.toggle_header);
  const { canAdd, canEdit, canDelete } = usePermissions();
  const {
    // loading,
    // error,
    values: { allWarehouse, total, loading, search, sort, pageValues },
    functions: { refetch, onChange, onChangeSort, handlePageChange },
  } = useWarehouse();
  const [selectedRow, setSelectedRow] = useState(null);

  const MySwal = withReactContent(Swal);

  console.log("WareHouses");

  const showConfirmationAlert = () => {
    MySwal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      confirmButtonText: "Yes, delete it!",
      cancelButtonColor: "#ff0000",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        MySwal.fire({
          title: "Deleted!",
          text: "Your file has been deleted.",
          className: "btn btn-success",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "btn btn-success",
          },
        });
      } else {
        MySwal.close();
      }
    });
  };
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };
  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      sorter: (a, b) => a.name.length - b.name.length,
    },
    {
      title: "Phone",
      dataIndex: "phone",
      sorter: (a, b) => a.phone.length - b.phone.length,
    },
    // {
    //   title: "CreatedOn",
    //   dataIndex: "createdAt",
    //   render: (text) => moment(text).format("DD-MM-YYYY"),
    //   sorter: (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
    // },
    // {
    //   title: "Status",
    //   dataIndex: "status",
    //   sorter: (a, b) => a.status.length - b.status.length,
    //   render: (text) => (
    //     <span
    //       className={`badge ${
    //         text === "Active" ? "badge-linesuccess" : "badge-bgdanger"
    //       }`}
    //     >
    //       {text}
    //     </span>
    //   ),
    // },
    ...(canEdit || canDelete
      ? [
          {
            title: "Actions",
            dataIndex: "actions",
            key: "actions",
            render: (text, record) => (
              <div className="action-table-data">
                <div className="edit-delete-action">
                  {canEdit && (
                    <Link
                      className="me-2 p-2"
                      to="#"
                      data-bs-toggle="modal"
                      data-bs-target="#edit-units"
                      onClick={() => setSelectedRow(record)}
                    >
                      <i data-feather="edit" className="feather-edit"></i>
                    </Link>
                  )}
                  {canDelete && (
                    <Link
                      className="confirm-text p-2"
                      to="#"
                      onClick={showConfirmationAlert}
                    >
                      <i data-feather="trash-2" className="feather-trash-2"></i>
                    </Link>
                  )}
                </div>
              </div>
            ),
          },
        ]
      : []),
  ];
  const options = [{ value: "name", label: "Sort By Name" }];
  const optionsTwo = [
    { label: "Choose Store Name", value: "" },
    { label: "Benjamin", value: "Benjamin" },
    { label: "Ellen", value: "Ellen" },
    { label: "Freda", value: "Freda" },
    { label: "Kaitlin", value: "Kaitlin" },
  ];

  const countries = [
    { label: "Choose Country", value: "" },
    { label: "India", value: "India" },
    { label: "USA", value: "USA" },
  ];

  // const renderPrinterTooltip = (props) => (
  //   <Tooltip id="printer-tooltip" {...props}>
  //     Printer
  //   </Tooltip>
  // );
  // const renderRefreshTooltip = (props) => (
  //   <Tooltip id="refresh-tooltip" {...props}>
  //     Refresh
  //   </Tooltip>
  // );
  // const renderCollapseTooltip = (props) => (
  //   <Tooltip id="refresh-tooltip" {...props}>
  //     Collapse
  //   </Tooltip>
  // );

  return (
    <div className="page-wrapper">
      <div className="content">
        <Breadcrumbs
          maintitle="Warehouse"
          subtitle="Manage Your Warehouse"
          addButton="Add New Warehouse"
          canAdd={canAdd}
        />

        {/* /product list */}
        <div className="card table-list-card">
          <div className="card-body">
            <div className="table-top">
              <div className="search-set">
                <div className="search-input">
                  <input
                    type="text"
                    placeholder="Search"
                    className="form-control form-control-sm formsearch"
                    aria-controls="DataTables_Table_0"
                    value={search}
                    onChange={(e) => onChange(e.target.value)}
                  />
                  <Link to className="btn btn-searchset">
                    <i data-feather="search" className="feather-search" />
                  </Link>
                </div>
              </div>
              <div className="search-path">
                <Link
                  className={`btn btn-filter ${
                    isFilterVisible ? "setclose" : ""
                  }`}
                  id="filter_search"
                >
                  <Filter
                    className="filter-icon"
                    onClick={toggleFilterVisibility}
                  />
                  <span onClick={toggleFilterVisibility}>
                    <ImageWithBasePath
                      src="assets/img/icons/closes.svg"
                      alt="img"
                    />
                  </span>
                </Link>
              </div>
              <div className="form-sort stylewidth">
                <Sliders className="info-img" />
                <Select
                  value={sort}
                  classNamePrefix="react-select"
                  className="img-select"
                  options={options}
                  placeholder="Sort By"
                  onChange={(selected) => {
                    onChangeSort(selected);
                  }}
                />
              </div>
            </div>
            {/* /Filter */}
            <div
              className={`card${isFilterVisible ? " visible" : ""}`}
              id="filter_inputs"
              style={{ display: isFilterVisible ? "block" : "none" }}
            >
              <div className="card-body pb-0">
                <div className="row">
                  <div className="col-lg-3 col-sm-6 col-12">
                    <div className="input-blocks">
                      <User className="info-img" />
                      <Select
                        classNamePrefix="react-select"
                        className="img-select"
                        options={optionsTwo}
                        placeholder="Choose Store Name"
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-sm-6 col-12">
                    <div className="input-blocks">
                      <Globe className="info-img" />
                      <Select
                        classNamePrefix="react-select"
                        className="img-select"
                        options={countries}
                        placeholder="Choose Country"
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-sm-6 col-12 ms-auto">
                    <div className="input-blocks">
                      <Link className="btn btn-filters ms-auto">
                        {" "}
                        <i
                          data-feather="search"
                          className="feather-search"
                        />{" "}
                        Search{" "}
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* /Filter */}
            <div className="table-responsive">
              <Table
                columns={columns}
                dataSource={allWarehouse?.data || []}
                total={total}
                onPageChange={handlePageChange}
                loading={loading}
                pagination={pageValues}
              />
            </div>
          </div>
        </div>
        {/* /product list */}
      </div>
      <AddWarehouse refetch={refetch} />
      <EditWarehouse rowData={selectedRow} refetch={refetch} />
    </div>
  );
};

export default WareHouses;
